import { ValidationMessages } from "@/types/functions";

const validationDE: ValidationMessages = {
    'min_length': '{field} trebuie să aibă cel puțin 0:{min} elemente selectate',
    'max_length': '{field} poate avea un maxim de 0:{max} elemente selectate',
    'multiple': 'Câmpul {field} trebuie să fie un multiplu de 0:{multiplu}.'
}

export default validationDE
